export default __webpack_public_path__ + "static/media/video2.7788be92.mp4";